<template>
  <div>
    <el-tabs v-model="activatedTabName">
      <el-tab-pane label="环境" name="environment">
        <EnvironmentListPage
          v-if="activatedTabName == 'environment'"
        ></EnvironmentListPage>
      </el-tab-pane>
      <el-tab-pane label="客户端强更新" name="forceUpdate">
        <ForceUpdateConfigPage
          v-if="activatedTabName == 'forceUpdate'"
        ></ForceUpdateConfigPage>
      </el-tab-pane>
      <el-tab-pane label="客户端热更新" name="hotUpdate">
        <HotUpdateConfigListPage
          v-if="activatedTabName == 'hotUpdate'"
        ></HotUpdateConfigListPage>
      </el-tab-pane>
      <el-tab-pane label="踢下线" name="kickOffline">
        <el-button
          style="margin-bottom: 10px"
          type="primary"
          icon="el-icon-warning-outline"
          @click="kickOfflineAllPlayers()"
          >所有玩家踢下线</el-button
        >
      </el-tab-pane>
      <el-tab-pane
        label="服务器更新"
        name="serverUpdate"
        v-if="
          $bizutil.isCloudNative() &&
          $bizutil.hasAnyPrivilege(['updateServers'])
        "
      >
        <ServerUpdatePage
          v-if="activatedTabName == 'serverUpdate'"
        ></ServerUpdatePage>
      </el-tab-pane>      
    </el-tabs>
  </div>
</template>

<script>
import EnvironmentListPage from "./tab-pages/EnvironmentListPage";
import ForceUpdateConfigPage from "./tab-pages/ForceUpdateConfigPage";
import HotUpdateConfigListPage from "./tab-pages/HotUpdateConfigListPage";
import ServerUpdatePage from "./tab-pages/ServerUpdatePage";

export default {
  data() {
    return {
      activatedTabName: "environment",
    };
  },

  components: {
    EnvironmentListPage,
    ForceUpdateConfigPage,
    HotUpdateConfigListPage,
    ServerUpdatePage,
  },

  methods: {
    async kickOfflineAllPlayers() {
      try {
        // 弹确认框
        await this.$confirm(`确认将所有玩家踢下线？`);
        let resData = (
          await axios.post(
            `${this.$util.getBackendApiBase()}/v1/admin/forceAllPlayersOffline`,
            {},
            {
              headers: {
                token: this.$bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$alert(resData.message, "提示", {
            center: true,
            type: "error",
            callback: (action) => {},
          });
          return;
        }

        this.$alert("操作成功（所有玩家将于1分钟内被踢下线）", "提示", {
          center: true,
          type: "success",
          callback: (action) => {},
        });
      } catch (error) {}
    },
  },
};
</script>